<template>
    <a-tabs v-model:activeKey="activeKey" size="large" @change="onChange"  @tabClick="onTabClick">
        <a-tab-pane key="RengongInfo" tab="使用辅导" ></a-tab-pane>
        <a-tab-pane key="RengongWlq" tab="未领取待邀评订单"></a-tab-pane>
        <a-tab-pane key="RengongYlqRw" tab="已领取待邀评订单"></a-tab-pane>
        <a-tab-pane key="RengongCPKPI" tab="邀评业绩"></a-tab-pane>
        <a-tab-pane key="RengongGrKPI" tab="客服邀评绩效"></a-tab-pane>
        <a-tab-pane key="RengongKfKPI" tab="评价详情"></a-tab-pane>
        <a-tab-pane key="RengongCXTool" tab="信息查询工具"></a-tab-pane>
        <a-tab-pane key="RengongFeigeMessageList" tab="飞鸽模板"></a-tab-pane>
        <a-tab-pane key="RengongKFManageDel" tab="客服删除"></a-tab-pane>
    </a-tabs>
  </template>
  <script>
  import { defineComponent, ref } from 'vue';
  export default defineComponent({
    setup() {
      return {
        
      };
    },
    data(){
        return {
            activeKey: ref('RengongInfo')
        }
    },
    props:['checktab'],
    mounted(){
        let num = this.checktab;
        this.activeKey = ref(num);
    },
    methods:{
        onTabClick(tabKey) {
              //console.log("tab clicked : " + tabKey);
          },
          onChange(tabKey) {
			//console.log("tab changed : " + tabKey);
			this.$router.push('/'+tabKey)
          }
    }
  });
  </script>
  <style>
  
  </style>